// extracted by mini-css-extract-plugin
module.exports = {"divNav":"Home_divNav__2mJaU","loading":"Home_loading__15CqJ","create":"Home_create__1KBEv","cards":"Home_cards__2wMhA"};